"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeOptins_en_us = void 0;
function backofficeOptins_en_us() {
    return {
        "backoffice.optins.title": "Consents",
        "backoffice.optins.subtitle": "Manage consent forms and opt-ins for your customers.",
        "backoffice.optins.create": "Create new Consent",
        "backoffice.optins.creationtitle": "Add new consent",
        "backoffice.optins.empty": "No Consents found",
        "backoffice.optins.nodescription": "No description found",
        "backoffice.optins.description": "Consents enable you to get permission from your customer on how to handle their data. Good examples are: Newsletter Opt-in, Data Privacy Policies or Terms & Conditions."
    };
}
exports.backofficeOptins_en_us = backofficeOptins_en_us;
